export default __webpack_public_path__ + "static/media/crypto.31ad2cd8.svg";